import React, { useEffect } from 'react';

// noorpassportservices.com/video -> explainer video on YouTube ("¿Cómo llenar su cheque?").
// A short, friendly address for the delivery emails; it forwards the visitor right away
// (no wait), so the page is barely visible.
const TARGET = 'https://www.youtube.com/shorts/uVMlkR0q3Rk';
export function VideoPage() {
  useEffect(() => {
    const m = document.createElement('meta');
    m.name = 'robots';
    m.content = 'noindex, nofollow';
    document.head.appendChild(m);
    window.location.replace(TARGET);
    return () => {
      m.remove();
    };
  }, []);
  return <div className="max-w-xl mx-auto px-4 py-16 text-center" data-id="element-764" data-mp="jdsm3qaqo5n0">
      <h1 className="text-2xl font-semibold mb-3" data-id="element-765" data-mp="jg6hk09bzjv3">Video paso a paso</h1>
      <p className="mb-6" data-id="element-766" data-mp="egablvh2picw">Le llevamos al video en YouTube…</p>
      <a href={TARGET} className="inline-block px-5 py-3 rounded-full bg-brand-textPrimary text-white" data-id="element-767" data-mp="tc00q2hk2blu">
        Ver el video
      </a>
    </div>;
}